module.exports = __webpack_public_path__ + "img/akord.1c983c98.png";